var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { computed, onMounted, ref } from 'vue';
import { useAudioHandler, useAudioUtils } from '@common/hooks';
import { generateUuid } from '@common/utils/Helpers/Helpers';
import { useCacheSession } from "@common/hooks/useCacheStorage/useCacheSession";
var ActiveAudio = /** @class */ (function () {
    function ActiveAudio() {
    }
    ActiveAudio.addSource = function (uuid, cb) {
        ActiveAudio.clearSources(uuid);
        ActiveAudio.instatnce[uuid] = cb;
    };
    ActiveAudio.clearSources = function (excludeUuid) {
        for (var instatnceKey in ActiveAudio.instatnce) {
            if (excludeUuid !== instatnceKey) {
                ActiveAudio.instatnce[instatnceKey]();
            }
        }
        ActiveAudio.instatnce = {};
    };
    ActiveAudio.instatnce = {};
    return ActiveAudio;
}());
export var useAudioControls = function (props) {
    var _intervalProgressId = null;
    var audioUtils = useAudioUtils();
    var audioHandler = useAudioHandler(props);
    var uuid = generateUuid();
    var audioInstance = ref(new Audio());
    var isRecordPlay = ref(false);
    var _currentTime = ref(0);
    var currentTimeFormat = computed(function () { return audioUtils.getTimeFormat(_currentTime.value); });
    var playbackRate = useCacheSession('playbackRate', 1);
    onMounted(function () {
        var audioSrc = props.audio instanceof Blob ? URL.createObjectURL(props.audio) : props.audio;
        audioInstance.value.src = audioSrc;
        audioInstance.value.addEventListener('ended', reset);
    });
    var _stopProgress = function () {
        if (_intervalProgressId) {
            clearInterval(_intervalProgressId);
        }
    };
    var _startProgress = function () {
        _stopProgress();
        _intervalProgressId = setInterval(_renderProgress, 100);
    };
    var play = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _startProgress();
                    return [4 /*yield*/, audioInstance.value.play()];
                case 1:
                    _a.sent();
                    isRecordPlay.value = true;
                    ActiveAudio.addSource(uuid, reset);
                    return [2 /*return*/];
            }
        });
    }); };
    var reset = function () {
        isRecordPlay.value && pause();
        audioInstance.value.currentTime = 0;
    };
    var pause = function () {
        audioInstance.value.pause();
        isRecordPlay.value = false;
    };
    var _updateCurrentTime = function () {
        _currentTime.value = audioInstance.value.currentTime;
    };
    var _renderProgress = function (progress) {
        var e_1, _a;
        _updateCurrentTime();
        var durationLocal = audioInstance.value.duration;
        var progressPercentage;
        if (!progress) {
            var durationMilliseconds = durationLocal * 1000;
            var currentTimeMilliseconds = audioInstance.value.currentTime * 1000;
            var onePercentage = durationMilliseconds / 100;
            progressPercentage = currentTimeMilliseconds / onePercentage;
        }
        else {
            progressPercentage = progress;
        }
        var onePercentBars = audioHandler.barsWithPercentage.value.length / 100;
        var progressBars = onePercentBars * progressPercentage;
        if (!isFinite(progressBars)) {
            console.error('Недопустимое значение прогресса');
            return;
        }
        try {
            for (var _b = __values(audioHandler.barsWithPercentage.value.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 1), index = _d[0];
                audioHandler.barsWithPercentage.value[index].isHeard = index + 1 <= progressBars;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    var toggleRecord = function () {
        (audioInstance.value.paused ? play() : pause());
    };
    var changeCurrentTime = function (progressPercent) {
        var validatePercent = function () {
            if (progressPercent > 100) {
                return 100;
            }
            if (progressPercent < 0) {
                return 0;
            }
            return progressPercent;
        };
        var duration = audioInstance.value.duration;
        var percent = validatePercent();
        var onePercent = duration * 1000 / 100;
        _renderProgress(percent);
        audioInstance.value.currentTime = onePercent * percent / 1000;
        !isRecordPlay.value && play();
    };
    var setPlaybackRate = function (rate) {
        playbackRate.value = rate;
        audioInstance.value.playbackRate = playbackRate.value;
    };
    var toggleRate = function () {
        if (playbackRate.value !== 1) {
            setPlaybackRate(1);
        }
        else {
            setPlaybackRate(1.5);
        }
    };
    return {
        play: play,
        pause: pause,
        toggleRecord: toggleRecord,
        renderPlayer: audioHandler.countBarsWithPercentage,
        barsWithPercentage: audioHandler.barsWithPercentage,
        changeCurrentTime: changeCurrentTime,
        isRecordPlay: isRecordPlay,
        currentTimeFormat: currentTimeFormat,
        toggleRate: toggleRate,
        playbackRate: playbackRate,
    };
};
